import { Skeleton, Divider, Menu, Select, Row, Col, Button, Modal, Upload, message, ConfigProvider, Tabs, Typography, Checkbox } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, RollbackOutlined, PlusOutlined, ArrowRightOutlined } from '@ant-design/icons';
import BlogCard from './components/BlogCard';
import ClassIntroduceModal from './components/ClassIntroduceModal';
import ClassIntroduceSortModal from './components/ClassIntroduceSortModal';
import WYSIWYGModal from './components/WYSIWYGModal';
import Carousel_news_ticker from './components/Carousel_news_ticker';
import PicModal from './components/PicModal';
// import InfiniteScroll from './components/InfiniteScroll';
import InfiniteScroll from 'react-infinite-scroll-component';
import Label_language from '../language';
import './css/cramSchool.css';
import TitleModal from './components/TitleModal';
import LessonModal from './components/LessonModal';
const { confirm } = Modal;
const { Title, Paragraph, Text, Link } = Typography;
const label_language = Label_language.cramschool.children
const ClassIntroduce = () => {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const navigate = useNavigate();
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [sloganFile, setSloganFile] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [title, setTitle] = useState(label_language.Common.children.add[language]);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [picOpen, setPicOpen] = useState(false);
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [open_wyswyg1, set_open_wyswyg1] = useState(false);
    const [title_modal, set_tiltle_modal] = useState(false);
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [titleEditcard, setTitleEditCard] = useState({ background_color: null, color_show: null, file_show: null, file_id: [], file_url: [] });
    const [content, setContent] = useState('');
    const [content1, setContent1] = useState('');
    const [data, setData] = useState([]);
    const [page, setpage] = useState(1);
    const [total, setTotal] = useState(1);
    const [itemdatacheck, setitemdatacheck] = useState(true);
    const [messageApi, contextHolder] = message.useMessage();
    const [permission, setPermission] = useState(false);
    const [sort, setSort] = useState(JSON.stringify({ column: 'annoucement_time', type: 'descend' }));
    const handleOnEdit = (key) => {
        setTitle(label_language.Common.children.edit[language]);
        setColor('f09a45');
        setEdit(true);
        data.map((value, index) => {
            if (index == key) {
                setEditCard((pre) => {
                    return ({
                        ...value,
                        font_color: value.font_color == null ? '#000000' : value.font_color,
                        background_color: value.background_color == null ? '#ffef9882' : value.background_color,
                        enroll_status_background_color: value.enroll_status_background_color == null ? '#FF0000' : value.enroll_status_background_color,
                        enroll_status_font_color: value.enroll_status_font_color == null ? '#FFFFFF' : value.enroll_status_font_color,
                        pic_background_color: value.pic_background_color == null ? '#FFFFFF' : value.pic_background_color,
                    })
                });
            }
        })
        setOpen(true)
    }
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/lesson_category', { params: { "blog_type_id": 5, order: [sort], cur_page: page, size: 9 } })
            .then((response) => {
                if (page == 1) {
                    setData(response.data.data);
                    setTotal(response.data.total)
                    get_picture(response.data.data);
                } else {
                    setData(pre => { return ([...pre, ...response.data.data]) });
                    setTotal(response.data.total)
                    get_picture([...data, ...response.data.data]);
                }
            })
            .finally(() => {
                setitemdatacheck(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/lesson_category', { params: { "blog_type_id": 8 } })
            .then((response) => {
                setContent(response.data.data[0]);
                getSloganFile(response.data.data[0].file_id);
            })
    }
    const getSloganFile = (data_tmp) => {
        const data_arr_tmp = [];
        if (data_tmp.length != 0) {
            data_tmp && data_tmp.map((value, index) => {
                axios
                    .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": value } })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/jpg",// this is the only MIME for SVG

                        });
                        const dataurl = URL.createObjectURL(blob_);
                        data_arr_tmp.push({ uid: value, url: dataurl })
                        setFileList(data_arr_tmp);
                    })
            })
        }
    }
    const get_title = () => {
        axios
            .get('/cramSchool/api/blog/type', { params: { 'blog_type_id': 11 } })
            .then((response) => {
                let color_tmp = response.data.data[0].background_color.split(',');
                // console.log(color_tmp);
                setTitleEditCard(
                    (pre) => {
                        return (
                            {
                                ...pre,
                                background_color1: color_tmp[0],
                                background_color2: color_tmp[1],
                                color_show: response.data.data[0].color_show,
                            }
                        )
                    }
                )
                if (response.data.data[0].file_id.length != 0) {
                    let data_tmp = [];
                    response.data.data[0].file_id.map((tmp, i) => {
                        axios
                            .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                            .then((response) => {
                                var blob_ = new Blob([response.data], {
                                    type: "image/jpg",// this is the only MIME for SVG

                                });
                                const dataurl = URL.createObjectURL(blob_);
                                data_tmp.push({ uid: tmp, url: dataurl })
                                setTitleEditCard((pre) => {
                                    if (tmp.file_url != undefined) {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [...tmp.file_id, tmp],
                                                file_url: [...tmp.file_url, dataurl]
                                            }
                                        )
                                    } else {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [tmp],
                                                file_url: [dataurl]
                                            }
                                        )
                                    }
                                })
                            })
                    })
                    setTitleEditCard((pre) => {
                        return (
                            {
                                ...pre,
                                file_show: response.data.data[0].file_show,
                                // file_id: data_tmp.map((item) => item.uid),
                                // file_url: data_tmp.map((item) => item.url)
                            }
                        )
                    })
                }
            })
    }
    const get_header1 = () => {
        axios
            .get('/cramSchool/api/blog/header/lesson', { params: { "blog_type_id": 14 } })
            .then((response) => {
                setContent1(response.data.data[0]);
            })
    }
    useEffect(() => {
        get_data();
        get_header();
        get_header1();
        get_title();
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
    }, [])
    const handleEdit = (file_id) => {
        setOpen(false);
        // let data_tmp = [{ ...editcard }];
        if (editcard['file_id'] == "{0}") {
            editcard['file_id'] = null;
        }
        // console.log(editcard); 
        axios
            .patch(`/cramSchool/api/blog/lesson_category`, [{ ...editcard, file_id, "blog_type_id": 5 }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                    get_data();
                }
            })
    }
    const handleSubmit = (file_id) => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            // console.log(editcard['annoucement_time']);
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            // console.log(editcard);
            axios
                .post(`/cramSchool/api/blog/lesson_category`, [{ ...editcard, file_id, "blog_type_id": 5 }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.add_error[language],
                        });
                        get_data();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.add_success[language],
                        });
                        get_data();
                    }
                })
            // console.log(editcard); 
        }
    }
    const handleDelete = (id) => {
        const deleterow = [{ "blog_id": id }];
        axios
            .delete('/cramSchool/api/blog/lesson_category', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.delete_error[language],
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.delete_success[language],
                    });
                    get_data();
                }
            })

    }
    const handleUpdate = (file_id) => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/lesson_category`, [
                {
                    // "title": 'lesson_category_header',
                    // "content": content,
                    ...content,
                    "blog_type_id": 8,
                    "annoucement_time": time,
                    // "blog_id": 107,
                    file_id
                }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_header();
                set_open_wyswyg(false);
                setPicOpen(false);
            })
    }
    useEffect(() => {
        data.forEach(each_item => {
            if (each_item.blog_id === editcard.blog_id) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [data])
    useEffect(() => {
        // console.log(sort);
        get_data();
    }, [sort])
    const [sortModalOpen, setSortModalOpen] = useState(false)
    const handleTitleUpdate = (file_id) => {
        // console.log({ ...titleEditcard, background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`, file_id: file_id });
        axios
            .patch('/cramSchool/api/blog/type', [{
                ...titleEditcard,
                background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`,
                file_id: file_id,
                blog_type_id: 11
            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_title();
            })
    }

    const handleUpdate1 = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/lesson`, [{
                // "title": 'lesson_header',
                // "content": content1,
                ...content1,
                "blog_type_id": 14,
                "annoucement_time": time,
            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_header1();
                set_open_wyswyg1(false);
            })
    }
    useEffect(() => {
        // console.log(page)
        get_data();
    }, [page])
    const ChangePage = () => {
        if (itemdatacheck) {
            return;
        }
        // setLoading(true);
        setitemdatacheck(false);
        setpage(pre => pre + 1)
    }
    return (
        <>
            {contextHolder}
            <ClassIntroduceModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                handleDelete={handleDelete}
            />
            <WYSIWYGModal
                open={open_wyswyg}
                setOpen={set_open_wyswyg}
                data={content?.content}
                setData={setContent}
                handleUpdate={handleUpdate}
            />
            <WYSIWYGModal
                open={open_wyswyg1}
                setOpen={set_open_wyswyg1}
                data={content1?.content}
                setData={setContent1}
                handleUpdate={handleUpdate1}
            />
            <TitleModal
                open={title_modal}
                setOpen={set_tiltle_modal}
                title={'修改'}
                color={'f09a45'}
                edit={true}
                name={'課程簡介'}
                editcard={titleEditcard}
                setEditCard={setTitleEditCard}
                handleEdit={handleTitleUpdate}
                fileShow={true}
            />
            <PicModal
                picOpen={picOpen}
                setPicOpen={setPicOpen}
                handleSubmit={handleUpdate}
                fileList={fileList}
            ></PicModal>
            <Row gutter={[8, 24]} justify={'end'}>
                {permission ? <>
                    <Col >
                        <Button className='example' style={{ backgroundColor: '#f09a45', color: '#FFFFFF' }} onClick={e => set_tiltle_modal(true)}>編輯標題</Button>
                    </Col>
                </> : null}
                <Col span={24} style={{ backgroundColor: '#ffef9882', paddingTop: '30px' }} hidden>
                    <Row align={'middle'}>
                        <Col md={{ span: 12 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                            <Row gutter={[8, 8]} justify={'center'} align={'middle'}>
                                <Col span={20}>
                                    <span dangerouslySetInnerHTML={{ __html: content.content }}></span>
                                </Col>
                            </Row>
                            {permission ? <>
                                <Col className='example' style={{ position: 'absolute', left: '90%', top: '0%' }}>
                                    <EditOutlined
                                        className='example'
                                        style={{
                                            backgroundColor: '#F9D4E5',
                                            fontSize: '1.2rem',
                                            borderRadius: '50%',
                                            padding: '8px'
                                        }}
                                        onClick={e => set_open_wyswyg(true)}
                                    />
                                </Col>
                            </> : null}
                        </Col>
                        <Col md={{ span: 12 }} sm={{ span: 24 }} >
                            <Carousel_news_ticker
                                width={'80%'}
                                height={'80%'}
                                file_url={fileList.map(map_item => map_item.url)}
                                backgroundColor={'#ffef9882'}
                            />
                            {permission ? <>
                                <Col className='example' style={{ position: 'absolute', left: '90%', top: '0%' }}>
                                    <EditOutlined
                                        className='example'
                                        style={{
                                            backgroundColor: '#F9D4E5',
                                            fontSize: '1.2rem',
                                            borderRadius: '50%',
                                            padding: '8px'
                                        }}
                                        onClick={e => setPicOpen(true)}
                                    />
                                </Col>
                            </> : null}
                        </Col>
                    </Row>
                </Col>
                {titleEditcard?.color_show == 1 ? <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${titleEditcard.background_color1}, #ffffff,${titleEditcard.background_color2})`, padding: '10px', position: 'relative' }}>
                        <Col style={{ textAlign: 'center' }}>
                            <span style={{ fontSize: '3rem' }}>{label_language.home.children.lesson_category[language]}</span>
                        </Col>
                        {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                        </Col> */}
                    </Row>
                </Col> : null}
                {titleEditcard?.file_show == 1 ? <Col span={24}>
                    <Carousel_news_ticker
                        logo
                        height={'100%'}
                        file_url={titleEditcard?.file_url != undefined && titleEditcard?.file_url.length != 0 && titleEditcard?.file_url.map(map_item => map_item)}
                    />
                </Col> : null}
                <Col span={24}>
                    <Row gutter={[40, 16]} justify="center" align="middle" style={{ padding: '10px' }}>
                        <Col md={{ span: 6 }} sm={{ span: 24 }}>
                            <Row gutter={[8, 8]}>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                            </Row>
                        </Col>
                        <Col md={{ span: 8 }} sm={{ span: 24 }} >
                            <Row justify={'center'}>
                                <Col >
                                    <span dangerouslySetInnerHTML={{ __html: content1.content }}></span>
                                </Col>
                            </Row>

                        </Col>
                        <Col md={{ span: 6 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                            <Row gutter={[8, 8]} >
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                            </Row>
                            {permission ? <>
                                <Col className='example' style={{ position: 'absolute', top: '-350%', left: 0 }}>
                                    <EditOutlined
                                        className='example'
                                        style={{
                                            backgroundColor: '#F9D4E5',
                                            fontSize: '1.2rem',
                                            borderRadius: '50%',
                                            padding: '8px'
                                        }}
                                        onClick={e => set_open_wyswyg1(true)}
                                    />
                                </Col>
                            </> : null}
                        </Col>
                    </Row>
                </Col>
                {permission ? <>
                    <Col span={24}>
                        <Row justify="end" gutter={[8, 8]} style={{ padding: '20px' }}>
                            <Col className='example'>
                                <Button style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle(label_language.Common.children.add[language]); setEditCard({}); setColor('d65b77'); setEditCard({}); setEdit(false); setOpen(true) }} icon={<PlusOutlined />}>{label_language.Common.children.add[language]}{label_language.ClassIntroduce.children.classintroduce[language]}</Button >
                            </Col>
                            <Col>
                                <Button
                                    onClick={() => setSortModalOpen(true)}
                                >修改貼文排序
                                </Button>
                                <ClassIntroduceSortModal
                                    data={data}
                                    open={sortModalOpen}
                                    edit={true}
                                    title={"修改排序"}
                                    color={"f09a45"}
                                    editcard={editcard}
                                    // setEditCard={setEditCard}
                                    setOpen={setSortModalOpen}
                                    get_data={get_data}
                                // handleEdit={handleEdit}
                                // handleSubmit={handleSubmit}
                                // handleDelete={handleDelete}
                                />
                            </Col>
                        </Row>
                    </Col>
                </> : null}
                <Col hidden>
                    <Select
                        defaultValue={[label_language.Common.children.new_old[language]]}
                        style={{
                            width: 120,
                        }}
                        onChange={value => { setSort(value) }}
                        options={[
                            {
                                label: label_language.Common.children.new_old[language],
                                value: JSON.stringify({ column: 'annoucement_time', type: 'descend' }),
                            },
                            {
                                label: label_language.Common.children.old_new[language],
                                value: JSON.stringify({ column: 'annoucement_time', type: 'ascend' }),
                            },
                            // {
                            //     value: 'yiminghe',
                            //     label: '點擊次數新-舊',
                            // },
                            // {
                            //     value: 'Disabled',
                            //     label: '點擊次數舊-新',
                            // },
                        ]}
                    />
                </Col>
                <Col span={24} >
                    {/* <InfiniteScroll
                        data={<BlogCard title={true} edit={permission} span={8} data={data} type={'straight'} page={'ClassIntroduce'} handleOnEdit={handleOnEdit} />}
                        page={page}
                        total={total}
                        setpage={e => setpage(e)}
                        loading={itemdatacheck}
                        size={9}
                        method="window" /> */}
                    <InfiniteScroll
                        dataLength={data?.length}
                        next={ChangePage}
                        hasMore={data?.length < total}
                        loader={
                            <Skeleton
                                paragraph={{
                                    rows: 1,
                                }}
                                active
                            />
                        }
                        endMessage={<Divider plain>已經沒有貼文囉</Divider>}
                        scrollableTarget="scrollableDiv"
                    >
                        <Row gutter={[16, 16]} style={{ padding: '10px' }}>
                            <BlogCard title={true}
                                edit={permission} span={8}
                                data={data} type={'straight'}
                                page={'ClassIntroduce'}
                                handleOnEdit={handleOnEdit} />
                        </Row>
                    </InfiniteScroll>
                    {/* <Row justify={'center'} gutter={[40, 8]}>
                                <BlogCard title={true} edit={permission} span={8} data={data} type={'straight'} page={'ClassIntroduce'} handleOnEdit={handleOnEdit} lesson_show={lesson_show} set_lesson_show={set_lesson_show} />
                            </Row> */}
                </Col>
            </Row >
        </>
    )

}

export default ClassIntroduce;
